<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>模拟PO冲突</v-card-title>
      <v-card-actions>
        <v-btn @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="cancel">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout column wrap>
              <v-text-field clearable label="QTY" v-model.number="form.qty"/>
              <v-text-field clearable label="PRICE" v-model.number="form.price"/>
              <remote-autocomplete label="BU" url="/divisions/kv?type=BU" v-model="form.buId"/>
              <v-select :items="status" v-model="form.status"/>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      status: [
        { text: 'PO变更', value: 'CONFLICT' },
        { text: 'PO取消', value: 'CANCEL' }
      ],
      show: false,
      resolve: null,
      reject: null
    }
  },
  methods: {
    params() {
      return {
        params: this.form
      }
    },
    save() {
      this.$http
        .get('/purchase-orders/mock-conflict', this.params())
        .then(res => {
          this.show = false
          this.resolve(res)
        })
    },
    popup(item) {
      this.show = true
      this.form.id = item.id
      this.form.qty = item.qty
      this.form.price = item.unitPrice
      this.form.buId = item.buId
      this.form.status = 'CONFLICT'
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    cancel() {
      this.show = false
    }
  }
}
</script>
